import React from 'react';
import { EventsGridGalleryItem } from 'src/modules/events/components/EventsGridGallery/EventsGridGalleryItem';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { media } from 'src/styles/designs';
import { Events } from 'src/graphql/schema.graphql';
import { StyleProps } from '@summer/jst-react';

export interface EventsGridGalleryProps {
  events: Events[];
}

const Container = styled(ConstraintContainer)`
  margin-top: 60px;

  ${media.w.greaterThanOrEqual.desktop} {
    margin-top: 80px;
  }
`;

const Content = styled(motion.ol)`
  display: grid;
  grid-gap: 30px;
  grid-auto-flow: row;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  margin: 0;

  ${media.w.lessThan.desktop} {
    grid-template-columns: 1fr;
  }

  ${media.w.greaterThanOrEqual.desktop} {
    grid-template-columns: 300px 300px 300px;
    grid-gap: 40px;
  }
`;

const animationConfig = {
  show: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

export const EventsGridGallery = ({
  events,
  ...props
}: EventsGridGalleryProps & StyleProps) => (
  <Container {...props}>
    <Content variants={animationConfig} initial="hide" animate="show">
      {events.map((a) => (
        <EventsGridGalleryItem event={a} key={a.id} />
      ))}
    </Content>
  </Container>
);
